import { action, observable, makeObservable } from 'mobx';
import {
  contentLoaders,
  ContentLookup,
  SuccessResponse,
  X1Language,
  X2AgeCategory,
  X3Level,
  X4Unit,
  X5Lesson,
  X5LessonUpdateModel
} from '../../../../domain';
import {
  Control,
  HttpPromiseState,
  newValueForSelection,
  SaveStateHolder,
  validators
} from '../../../../lib/helpers';

export class MoveLessonStore implements SaveStateHolder {
  language: Control<X1Language | null>;
  ageCategory: Control<X2AgeCategory | null>;
  level: Control<X3Level | null>;
  unit: Control<X4Unit | null>;

  @observable.ref
  readonly languageOptions: readonly X1Language[];
  @observable.ref
  ageCategoryOptions: readonly X2AgeCategory[];
  @observable.ref
  levelOptions: readonly X3Level[];
  @observable.ref
  unitOptions: readonly X4Unit[];

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly lesson: X5Lesson,
              readonly lookup: ContentLookup) {
    makeObservable(this);
    this.language = new Control<X1Language | null>(
      'Language',
      lesson.Unit!.Level!.AgeCategory!.Language,
      validators.required
    );

    this.language.addValueChangeListener((language) => {
      this.ageCategoryOptions = [];
      if (language !== null)
        this.ageCategoryOptions = language.AgeCategories!;
      const newValue = newValueForSelection(this.ageCategoryOptions, this.ageCategory.value);
      this.ageCategory.setValue(newValue);
    });

    this.ageCategory = new Control<X2AgeCategory | null>(
      'AgeCategory',
      lesson.Unit!.Level!.AgeCategory,
      validators.required
    );

    this.ageCategory.addValueChangeListener((ageCategory) => {
      this.levelOptions = [];
      if (ageCategory !== null)
        this.levelOptions = ageCategory.Levels!;
      const newValue = newValueForSelection(this.levelOptions, this.level.value);
      this.level.setValue(newValue);
    });

    this.level = new Control<X3Level | null>(
      'Level',
      lesson.Unit!.Level,
      validators.required
    );

    this.level.addValueChangeListener((level) => {
      this.unitOptions = [];
      if (level !== null)
        this.unitOptions = level.Units!;
      const newValue = newValueForSelection(this.unitOptions, this.unit.value);
      this.unit.setValue(newValue);
    });

    this.unit = new Control<X4Unit | null>(
      'Level',
      lesson.Unit,
      validators.required
    );

    this.languageOptions = lookup.Languages;
    this.ageCategoryOptions = lesson.Unit!.Level!.AgeCategory!.Language!.AgeCategories!;
    this.levelOptions = lesson.Unit!.Level!.AgeCategory!.Levels!;
    this.unitOptions = lesson.Unit!.Level!.Units!;

    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.language.markTouched();
    this.ageCategory.markTouched();
    this.level.markTouched();
    this.unit.markTouched();
    if (this.unit.invalid)
      return;

    const model: X5LessonUpdateModel = {
      UnitId: this.unit.value!.Id,
      LessonType: this.lesson.LessonType,
      Name: this.lesson.Name
    };
    this.save = contentLoaders.x5lesson.update(this.lesson.Id, model);
  }
}
